import roleAccess from './role-access'
import user from './user'

export default [...roleAccess, ...user]
